import React from "react";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";

const BLOG_SUBDOMAIN = "https://blog.svsnursingcollege.com/";

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <PageHero
        overline="Insights"
        title={<>From our <span className="italic text-gold-gradient">blog</span></>}
        subtitle="Articles, updates and stories on nursing education, careers, admissions and campus life at SVS College of Nursing."
      />
      <section className="bg-sand py-14">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="flex justify-end mb-5">
            <a
              href={BLOG_SUBDOMAIN}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="open-blog-external"
              className="inline-flex items-center gap-2 text-navy font-semibold hover:text-gold transition-colors"
            >
              Open blog in new tab <ArrowUpRight size={18} />
            </a>
          </div>
          <div className="relative w-full overflow-hidden rounded-[2px] border border-navy/10 shadow-[0_20px_60px_rgba(10,30,77,0.1)] bg-white">
            <iframe
              title="SVS College of Nursing Blog"
              src={BLOG_SUBDOMAIN}
              data-testid="blog-iframe"
              className="w-full border-0"
              style={{ height: "1400px" }}
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
